import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { IInlineElement, InlineConfirmContainer } from './inline-confirm-container';

@autoinject
export class InlineButton implements IInlineElement {
	@bindable type: string;
	@bindable buttonType: string;
	@bindable buttonBehavior;
	@bindable label: string;
	@bindable size: string;
	@bindable clicking: () => void;

	visible = true;

	constructor(private container: InlineConfirmContainer) {
		container.addElement(this);
	}

	@computedFrom('buttonType')
	get buttonTypeClass() {
		if (!this.buttonType) {
			return 'btn-default';
		}

		return `btn-${this.buttonType.toLowerCase()}`;
	}

	@computedFrom('size')
	get sizeClass() {
		if (!this.size || this.size === 'md') {
			return '';
		}

		return `btn-${this.size.toLowerCase()}`;
	}

	hide() {
		this.visible = false;
	}

	show() {
		this.visible = true;
	}

	click() {
		if (this.clicking != null) {
			this.clicking();
			return false;
		}

		if (this.buttonBehavior && this.buttonBehavior.toLowerCase() === 'submit') {
			return true;
		}

		return false;
	}
}
